import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: theme.spacing(3),
  },
  infoBox: {
    backgroundColor: theme.palette.neutral.lightest,
    padding: theme.spacing(2.5),
  },
  infoBoxLabel: {
    marginBottom: theme.spacing(1),
    color: theme.palette.neutral.main,
  },
  infoBoxInfo: {
    color: theme.palette.neutral.dark,
  },
  alert: {
    margin: theme.spacing(2, 0, 4),
    '& .MuiAlert-icon': {
      alignSelf: 'center',
    },
  },
}))

export default useStyles
